import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { isEmpty } from 'lodash';
import Truncate from 'react-truncate';
import { setCareerTab } from '../../../store/actions';
import { getOnboardingState } from '../../../store/selectors';
import DeselectPathLink from './DeselectPathLink';
import InformationIcon from '../../utility/InformationIcon';
import LearnMoreLink from './LearnMoreLink';
import { modalOpen_GTM } from '../../../gtm/datalayers/utilDataLayers.json';

// Add the little yellow box underneath each career tab/card
function PathChosenAddon(props) {
  const pathAddonPrimary = {
    background: `${props.tenant.primary}`,
  };

  const reselectDegree = () => {
    props.setCareerTab(props.onboarding.degreeChoices, true, props.tabNumber);
  };

  // If all career paths have been chosen, show the extended version of this component with the 'Learn more' and info icon
  const handleAllPathsChosen = (allPathsProps) => {
    if (!allPathsProps.onboarding.degreeChoices[allPathsProps.tabNumber]) {
      return (
        <>
          <p className="inactive-degree-text">
            The paired degree is no longer available.
          </p>
          <button
            onClick={reselectDegree()}
            className="inactive-path-text"
            type="button"
          >
            Select new degree
          </button>
        </>
      );
    }

    const checkPathsChosen = () => {
      return Object.values(allPathsProps.onboarding.degreeChoices).filter(
        (degreeChoice) => {
          return degreeChoice.id;
        }
      );
    };

    return checkPathsChosen() === 3 ? (
      <>
        <p className="degree-title-text" data-cy="yellow-path-added">
          <Truncate lines={1} ellipsis="..." width={180}>
            {
              allPathsProps.onboarding.degreeChoices[allPathsProps.tabNumber]
                .titleEn
            }
          </Truncate>
        </p>
        <DeselectPathLink
          tabNumber={allPathsProps.tabNumber}
          tenant={props.tenant}
          data-cy="remove-path-link"
        />
      </>
    ) : (
      <div className="paths-content-container">
        <div className="all-path-chosen-content">
          <div className="career-info-icon-learn-more">
            <p className="degree-title-text" data-cy="yellow-path-added">
              <Truncate lines={1} ellipsis="...">
                {
                  allPathsProps.onboarding.degreeChoices[
                    allPathsProps.tabNumber
                  ].titleEn
                }
              </Truncate>
            </p>
          </div>
          <DeselectPathLink
            tabNumber={allPathsProps.tabNumber}
            tenant={props.tenant}
            data-cy="remove-path-link"
          />
        </div>
        <Link
          to={{
            pathname: props.location.pathname,

            search: `degree=${encodeURIComponent(
              allPathsProps.onboarding.degreeChoices[allPathsProps.tabNumber]
                .titleEn
            )} degreeId ${
              allPathsProps.onboarding.degreeChoices[allPathsProps.tabNumber].id
            }`,
          }}
          aria-label={`click to open info modal for ${
            allPathsProps.onboarding.degreeChoices[allPathsProps.tabNumber]
              .titleEn
          }`}
          className="info-icon-learn-more"
        >
          <InformationIcon
            color="#FFFFFF"
            gtmObj={modalOpen_GTM}
            section={
              allPathsProps.onboarding.degreeChoices[allPathsProps.tabNumber]
                .titleEn
            }
            component={
              allPathsProps.onboarding.careerChoices[allPathsProps.tabNumber]
                .titleEn
            }
            text="information"
            modalImage={allPathsProps.modalImage}
            tabIndex="-1"
          />
          <LearnMoreLink
            tenant={props.tenant}
            section={
              allPathsProps.onboarding.degreeChoices[allPathsProps.tabNumber]
                .titleEn
            }
            component={
              allPathsProps.onboarding.careerChoices[allPathsProps.tabNumber]
                .titleEn
            }
            modalImage={allPathsProps.modalImage}
            ariaLabel={`Learn more about ${
              allPathsProps.onboarding.degreeChoices[allPathsProps.tabNumber]
                .titleEn
            }`}
            tabIndex="-1"
          />
        </Link>
      </div>
    );
  };

  const showInactiveDegree = () => {
    return !isEmpty(props.onboarding.degreeChoices[props.tabNumber]) ? (
      <>
        <p className="degree-title-text" data-cy="yellow-path-added">
          <Truncate lines={1} ellipsis="...">
            {props.onboarding.degreeChoices[props.tabNumber].titleEn}
          </Truncate>
        </p>
        <DeselectPathLink tabNumber={props.tabNumber} tenant={props.tenant} />
      </>
    ) : (
      <>
        <p className="inactive-degree-text">
          The paired degree is no longer available.
        </p>
        <button
          onClick={() => reselectDegree()}
          className="inactive-path-text"
          type="button"
        >
          Select new degree
        </button>
      </>
    );
  };

  return (
    <div
      className={
        props.onboarding.careerTabSelected
          ? 'path-chosen-addon-container'
          : 'path-chosen-addon-container-expanded'
      }
      style={pathAddonPrimary}
    >
      {props.onboarding.careerTabSelected
        ? showInactiveDegree()
        : handleAllPathsChosen(props)}
    </div>
  );
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);

  return { onboarding };
};

export default withRouter(
  connect(mapStateToProps, { setCareerTab })(PathChosenAddon)
);
